"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarTabs = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
function SidebarTabs({ selectedTab, onTabClick, tabs, }) {
    return ((0, jsx_runtime_1.jsx)(TabsContainer, { "data-e2e": 'SidebarTabs_TabsContainer', children: Object.values(tabs).map(tab => ((0, jsx_runtime_1.jsx)(Button, { tabIndex: 0, isSelected: selectedTab === tab, onClick: () => onTabClick(tab), "data-e2e": 'SidebarTabs_Button', children: String(tab) }, String(tab)))) }));
}
exports.SidebarTabs = SidebarTabs;
const TabsContainer = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 10px;
  border-bottom: 1px solid ${({ theme }) => theme.grasshopper.borders.grey};
`;
const Button = styled_components_1.default.button `
  cursor: pointer;
  background: none;
  border: none;
  white-space: nowrap;
  font-weight: 400;
  font-size: 20px;
  padding: 8px;
  background-color: ${({ theme }) => theme.grasshopper.background};
  padding-right: 16px;
  padding-left: 16px;

  &:focus-visible {
    outline: none;
    border: 2px solid ${({ theme }) => theme.designSystem.accent};
  }

  ${({ theme, isSelected }) => isSelected &&
    (0, styled_components_1.css) `
      border-bottom: 4px solid ${theme.grasshopper.borders.white};
    `}

  color: ${({ theme, isSelected }) => isSelected
    ? theme.grasshopper.overlayPanel.textColor
    : theme.grasshopper.overlayPanel.disabledText};

  &:hover {
    ${({ theme, isSelected }) => !isSelected &&
    (0, styled_components_1.css) `
        color: ${theme.grasshopper.overlayPanel.textColor};
        opacity: 0.8;
      `}
  }
`;
